import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Text, StatusColorIndicator, Tooltip } from '@adsk/bim360-matrix-react-components';
import { statusColorMapping } from '../../../../../../../constants/status-types';
import T from 'i18n-react';

/**
 * Status cell
 */
const StatusCell = (props) => {
  const { showText, status, smallIndicators, container } = props;

  const showTooltip = !showText;
  const statusColor = statusColorMapping[status];
  const statusText = T.translate(`status.${status}`);
  const tooltipClassName = `StatusCell__tooltip__${statusColor} StatusColorIndicator__${statusColor}`;

  const statusIndicatorClassNames = classNames('StatusCell__indicator', {
    'StatusCell__indicator--small': smallIndicators,
  });

  const statusIndicator = <StatusColorIndicator classNames={statusIndicatorClassNames} statusColor={statusColor} />;
  return (
    <div className="StatusCell">
      {showTooltip ? (
        <Tooltip
          tooltipClassName={tooltipClassName}
          content={statusText}
          place={Tooltip.Places.RIGHT}
          container={container}
          matchArrowBackground
        >
          {statusIndicator}
        </Tooltip>
      ) : (
          <Fragment>
            {statusIndicator}
            {showText && <Text className="StatusCell__text" ellipsis>{statusText}</Text>}
          </Fragment>
        )}
    </div>
  );
};

StatusCell.defaultProps = {
  showText: true,
};

StatusCell.propTypes = {
  status: PropTypes.string.isRequired,
  showText: PropTypes.bool,
  smallIndicators: PropTypes.bool,
  container: PropTypes.object.isRequired,
};

export default StatusCell;
